const reverseObj = (obj) => {
  let newObj = {};
  Object.keys(obj)
    .sort()
    .reverse()
    .forEach((key) => {
      newObj[key] = obj[key];
    });
  return newObj;
};

function supplementCart(r) {
  reverseObj(r.items);
  r.items.forEach((e) => {
    e.tags = window.vars.productTags[e.product_id];

    e.product_metafields = window.vars.productMetafields?.[e.product_id] || {
  default_data: '',
  offer_badge: '',
   halo_color: ''

  //  price code
  
};
    e.halo_style = `--halo_colour: ${e.product_metafields.halo_color || '#ccc'}`;

    //   if (typeof e.price === "number") {
    //   let money = (e.price / 100).toFixed(2).split(".");
    //   let format = window?.Shopify?.money_format || "${{amount}}";
    //   let match = format.match(/[^{}0-9.,\s]+/);
      
    //   e.price_symbol = match ? match[0] : "$";

    //   e.price_whole = money[0];
    //   e.price_decimal = money[1] === "00" ? null : money[1];
    // }
    if (typeof e.price === "number") {
  let money = (e.price / 100).toFixed(2).split(".");
  let format = window?.Shopify?.money_format || "${{amount}}";
  let match = format.match(/[^{}0-9.,\s]+/);

  e.price_symbol = match ? match[0] : "$";
  e.price_whole = money[0];
  e.price_decimal = money[1] === "00" ? null : "." + money[1]; // add dot only if decimal part exists
}

    var t,
      n = window.vars.bundleOfferData.find((t) => t.id === e.product_id);
    n &&
      (({ image: n, svg: t } = n),
      (e.addon_image = n),
      (e.addon_svg = t),
      (e.showImage = n || t));
  });
  r.items_original = JSON.parse(JSON.stringify(r.items));

  var t = r.items.map((t) =>
      Array.apply(null, Array(t.quantity)).map(function () {
        return t;
      })
    ),
    t =
      ((r.items_unbundled = [].concat.apply([], t)),
      r.items
        .map((t) => {
          const e = t.properties._bundle_id,
            n = -1 === t.tags.indexOf("offer:bundle");
          var i = r.items.find(
            (t) =>
              t.properties._bundle_id === e &&
              (n
                ? -1 !== t.tags.indexOf("offer:bundle")
                : -1 === t.tags.indexOf("offer:bundle"))
          );
          return n ? (i ? null : t) : i ? { ...t, addOn: i } : t;
        })
        .filter((t) => null !== t)
        .map((t) =>
          Array.apply(null, Array(t.quantity)).map(function () {
            return t;
          })
        )),
    t = [].concat.apply([], t);
  return (r.items = t), (r.item_count = t.length), r;
}


// function supplementCart(r) {
//   r.items.forEach((e) => {
//     e.tags = window.vars.productTags[e.product_id];

//     const bundleData = window.vars.bundleOfferData.find((b) => b.id === e.product_id);
//     if (bundleData) {
//       e.addon_image = bundleData.image;
//       e.addon_svg = bundleData.svg;
//       e.showImage = bundleData.image || bundleData.svg;
//     }
//   });

//   // No duplication here
//   r.items_unbundled = r.items;

//   // Optional: keep item_count based on real count, or sum of quantities
//   r.item_count = r.items.reduce((sum, item) => sum + item.quantity, 0);

//   return r;
// }


!function () {
  function i(t, e, n, i) {
    return new r(t, e, n, i);
  }
  function r(t, e, n, i) {
    (this.options = i || {}),
      (this.options.adapters = this.options.adapters || {}),
      (this.obj = t),
      (this.keypath = e),
      (this.callback = n),
      (this.objectPath = []),
      (this.update = this.update.bind(this)),
      this.parse(),
      s((this.target = this.realize())) &&
        this.set(!0, this.key, this.target, this.callback);
  }
  function s(t) {
    return "object" == typeof t && null !== t;
  }
  function o(t) {
    throw new Error("[sightglass] " + t);
  }
  (i.adapters = {}),
    (r.tokenize = function (t, e, n) {
      for (var i, r = [], s = { i: n, path: "" }, o = 0; o < t.length; o++)
        (i = t.charAt(o)),
          ~e.indexOf(i) ? (r.push(s), (s = { i: i, path: "" })) : (s.path += i);
      return r.push(s), r;
    }),
    (r.prototype.parse = function () {
      var t,
        e,
        n = this.interfaces();
      n.length || o("Must define at least one adapter interface."),
        (e = ~n.indexOf(this.keypath[0])
          ? ((t = this.keypath[0]), this.keypath.substr(1))
          : (void 0 === (t = this.options.root || i.root) &&
              o("Must define a default root adapter."),
            this.keypath)),
        (this.tokens = r.tokenize(e, n, t)),
        (this.key = this.tokens.pop());
    }),
    (r.prototype.realize = function () {
      var n,
        i = this.obj,
        r = !1;
      return (
        this.tokens.forEach(function (t, e) {
          s(i)
            ? (void 0 !== this.objectPath[e]
                ? i !== (n = this.objectPath[e]) &&
                  (this.set(!1, t, n, this.update),
                  this.set(!0, t, i, this.update),
                  (this.objectPath[e] = i))
                : (this.set(!0, t, i, this.update), (this.objectPath[e] = i)),
              (i = this.get(t, i)))
            : (!1 === r && (r = e),
              (n = this.objectPath[e]) && this.set(!1, t, n, this.update));
        }, this),
        !1 !== r && this.objectPath.splice(r),
        i
      );
    }),
    (r.prototype.update = function () {
      var t, e;
      (t = this.realize()) !== this.target &&
        (s(this.target) && this.set(!1, this.key, this.target, this.callback),
        s(t) && this.set(!0, this.key, t, this.callback),
        (e = this.value()),
        (this.target = t),
        this.value() instanceof Function || this.value() !== e) &&
        this.callback();
    }),
    (r.prototype.value = function () {
      if (s(this.target)) return this.get(this.key, this.target);
    }),
    (r.prototype.setValue = function (t) {
      s(this.target) &&
        this.adapter(this.key).set(this.target, this.key.path, t);
    }),
    (r.prototype.get = function (t, e) {
      return this.adapter(t).get(e, t.path);
    }),
    (r.prototype.set = function (t, e, n, i) {
      t = t ? "observe" : "unobserve";
      this.adapter(e)[t](n, e.path, i);
    }),
    (r.prototype.interfaces = function () {
      var e = Object.keys(this.options.adapters);
      return (
        Object.keys(i.adapters).forEach(function (t) {
          ~e.indexOf(t) || e.push(t);
        }),
        e
      );
    }),
    (r.prototype.adapter = function (t) {
      return this.options.adapters[t.i] || i.adapters[t.i];
    }),
    (r.prototype.unobserve = function () {
      var n;
      this.tokens.forEach(function (t, e) {
        (n = this.objectPath[e]) && this.set(!1, t, n, this.update);
      }, this),
        s(this.target) && this.set(!1, this.key, this.target, this.callback);
    }),
    "undefined" != typeof module && module.exports
      ? (module.exports = i)
      : "function" == typeof define && define.amd
      ? define([], function () {
          return (this.sightglass = i);
        })
      : (this.sightglass = i);
}.call(this),
  function () {
    function y(t, e) {
      return function () {
        return t.apply(e, arguments);
      };
    }
    function t(t, e) {
      for (var n in e) s.call(e, n) && (t[n] = e[n]);
      function i() {
        this.constructor = t;
      }
      (i.prototype = e.prototype),
        (t.prototype = new i()),
        (t.__super__ = e.prototype);
    }
    var _,
      i,
      r,
      e,
      n,
      f = [].slice,
      s = {}.hasOwnProperty,
      h =
        [].indexOf ||
        function (t) {
          for (var e = 0, n = this.length; e < n; e++)
            if (e in this && this[e] === t) return e;
          return -1;
        };
    function o() {}
    function a() {}
    function u(t, e, n) {
      var i, r, s, o, a, u, l, c, h, d, p, f, v;
      for (
        this.els = t,
          this.models = e,
          null == n && (n = {}),
          this.update = y(this.update, this),
          this.publish = y(this.publish, this),
          this.sync = y(this.sync, this),
          this.unbind = y(this.unbind, this),
          this.bind = y(this.bind, this),
          this.select = y(this.select, this),
          this.traverse = y(this.traverse, this),
          this.build = y(this.build, this),
          this.buildBinding = y(this.buildBinding, this),
          this.bindingRegExp = y(this.bindingRegExp, this),
          this.options = y(this.options, this),
          this.els.jquery ||
            this.els instanceof Array ||
            (this.els = [this.els]),
          a = 0,
          l = (h = _.extensions).length;
        a < l;
        a++
      ) {
        if (((this[(r = h[a])] = {}), n[r]))
          for (i in (d = n[r])) (s = d[i]), (this[r][i] = s);
        for (i in (p = _.public[r]))
          (s = p[i]), null == (o = this[r])[i] && (o[i] = s);
      }
      for (u = 0, c = (f = _.options).length; u < c; u++)
        this[(r = f[u])] = null != (v = n[r]) ? v : _.public[r];
      this.build();
    }
    function l(t, e, n, i, r) {
      (this.view = t),
        (this.el = e),
        (this.type = n),
        (this.keypath = i),
        (this.options = null != r ? r : {}),
        (this.getValue = y(this.getValue, this)),
        (this.update = y(this.update, this)),
        (this.unbind = y(this.unbind, this)),
        (this.bind = y(this.bind, this)),
        (this.publish = y(this.publish, this)),
        (this.sync = y(this.sync, this)),
        (this.set = y(this.set, this)),
        (this.eventHandler = y(this.eventHandler, this)),
        (this.formattedValue = y(this.formattedValue, this)),
        (this.parseTarget = y(this.parseTarget, this)),
        (this.observe = y(this.observe, this)),
        (this.setBinder = y(this.setBinder, this)),
        (this.formatters = this.options.formatters || []),
        (this.dependencies = []),
        (this.formatterObservers = {}),
        (this.model = void 0),
        this.setBinder();
    }
    function c(t, e, n) {
      var i, r, s, o, a, u, l;
      for (
        this.view = t,
          this.el = e,
          this.type = n,
          this.unbind = y(this.unbind, this),
          this.bind = y(this.bind, this),
          this.locals = y(this.locals, this),
          this.component = this.view.components[this.type],
          this.static = {},
          this.observers = {},
          this.upstreamObservers = {},
          r = t.bindingRegExp(),
          o = 0,
          a = (u = this.el.attributes || []).length;
        o < a;
        o++
      )
        (i = u[o]),
          r.test(i.name) ||
            ((s = this.camelCase(i.name)),
            0 <= h.call(null != (l = this.component.static) ? l : [], s)
              ? (this.static[s] = i.value)
              : (this.observers[s] = i.value));
    }
    function d(t, e, n, i, r) {
      (this.view = t),
        (this.el = e),
        (this.type = n),
        (this.keypath = i),
        (this.options = null != r ? r : {}),
        (this.sync = y(this.sync, this)),
        (this.formatters = this.options.formatters || []),
        (this.dependencies = []),
        (this.formatterObservers = {});
    }
    (_ = {
      options: [
        "prefix",
        "templateDelimiters",
        "rootInterface",
        "preloadData",
        "handler",
      ],
      extensions: ["binders", "formatters", "components", "adapters"],
      public: {
        binders: {},
        components: {},
        formatters: {},
        adapters: {},
        prefix: "rv",
        templateDelimiters: ["{", "}"],
        rootInterface: ".",
        preloadData: !0,
        handler: function (t, e, n) {
          return this.call(t, e, n.view.models);
        },
        configure: function (t) {
          var e, n, i, r;
          for (i in (t = null == t ? {} : t))
            if (
              ((r = t[i]),
              "binders" === i ||
                "components" === i ||
                "formatters" === i ||
                "adapters" === i)
            )
              for (n in r) (e = r[n]), (_[i][n] = e);
            else _.public[i] = r;
        },
        bind: function (t, e, n) {
          return (
            (t = new _.View(
              t,
              (e = null == e ? {} : e),
              (n = null == n ? {} : n)
            )).bind(),
            t
          );
        },
        init: function (t, e, n) {
          return (
            null == n && (n = {}),
            null == e && (e = document.createElement("div")),
            (t = _.public.components[t]),
            (e.innerHTML = t.template.call(this, e)),
            (t = t.initialize.call(this, e, n)),
            (n = new _.View(e, t)).bind(),
            n
          );
        },
      },
    }),
      window.jQuery || window.$
        ? ((e = "on" in jQuery.prototype ? ["on", "off"] : ["bind", "unbind"]),
          (i = e[0]),
          (r = e[1]),
          (_.Util = {
            bindEvent: function (t, e, n) {
              return jQuery(t)[i](e, n);
            },
            unbindEvent: function (t, e, n) {
              return jQuery(t)[r](e, n);
            },
            getInputValue: function (t) {
              t = jQuery(t);
              return "checkbox" === t.attr("type") ? t.is(":checked") : t.val();
            },
          }))
        : (_.Util = {
            bindEvent:
              "addEventListener" in window
                ? function (t, e, n) {
                    return t.addEventListener(e, n, !1);
                  }
                : function (t, e, n) {
                    return t.attachEvent("on" + e, n);
                  },
            unbindEvent:
              "removeEventListener" in window
                ? function (t, e, n) {
                    return t.removeEventListener(e, n, !1);
                  }
                : function (t, e, n) {
                    return t.detachEvent("on" + e, n);
                  },
            getInputValue: function (t) {
              var e, n, i, r;
              if ("checkbox" === t.type) return t.checked;
              if ("select-multiple" !== t.type) return t.value;
              for (r = [], n = 0, i = t.length; n < i; n++)
                (e = t[n]).selected && r.push(e.value);
              return r;
            },
          }),
      (_.TypeParser =
        ((o.types = { primitive: 0, keypath: 1 }),
        (o.parse = function (t) {
          return /^'.*'$|^".*"$/.test(t)
            ? { type: this.types.primitive, value: t.slice(1, -1) }
            : "true" === t
            ? { type: this.types.primitive, value: !0 }
            : "false" === t
            ? { type: this.types.primitive, value: !1 }
            : "null" === t
            ? { type: this.types.primitive, value: null }
            : "undefined" === t
            ? { type: this.types.primitive, value: void 0 }
            : !1 === isNaN(Number(t))
            ? { type: this.types.primitive, value: Number(t) }
            : { type: this.types.keypath, value: t };
        }),
        o)),
      (_.TextTemplateParser =
        ((a.types = { text: 0, binding: 1 }),
        (a.parse = function (t, e) {
          for (var n, i, r, s = [], o = t.length, a = 0; a < o; ) {
            if ((r = t.indexOf(e[0], a)) < 0) {
              s.push({ type: this.types.text, value: t.slice(a) });
              break;
            }
            if (
              (0 < r &&
                a < r &&
                s.push({ type: this.types.text, value: t.slice(a, r) }),
              (a = r + e[0].length),
              (r = t.indexOf(e[1], a)) < 0)
            ) {
              (n = t.slice(a - e[1].length)),
                (null != (i = s[s.length - 1]) ? i.type : void 0) ===
                this.types.text
                  ? (i.value += n)
                  : s.push({ type: this.types.text, value: n });
              break;
            }
            (i = t.slice(a, r).trim()),
              s.push({ type: this.types.binding, value: i }),
              (a = r + e[1].length);
          }
          return s;
        }),
        a)),
      (_.View =
        ((u.prototype.options = function () {
          for (
            var t,
              e = {},
              n = _.extensions.concat(_.options),
              i = 0,
              r = n.length;
            i < r;
            i++
          )
            e[(t = n[i])] = this[t];
          return e;
        }),
        (u.prototype.bindingRegExp = function () {
          return new RegExp("^" + this.prefix + "-");
        }),
        (u.prototype.buildBinding = function (t, e, n, r) {
          var s,
            o,
            i = {},
            a = (function () {
              for (
                var t = r.split("|"), e = [], n = 0, i = t.length;
                n < i;
                n++
              )
                (o = t[n]), e.push(o.trim());
              return e;
            })(),
            u = (function () {
              for (
                var t = a.shift().split("<"), e = [], n = 0, i = t.length;
                n < i;
                n++
              )
                (s = t[n]), e.push(s.trim());
              return e;
            })(),
            l = u.shift();
          return (
            (i.formatters = a),
            (u = u.shift()) && (i.dependencies = u.split(/\s+/)),
            this.bindings.push(new _[t](this, e, n, l, i))
          );
        }),
        (u.prototype.build = function () {
          var t, v, e, n, i, y;
          for (
            this.bindings = [],
              v = function (r) {
                var t, e, n, s, i, o, a, u, l, c, h, d, p, f;
                if (3 === r.nodeType) {
                  if (
                    ((i = _.TextTemplateParser),
                    (n = y.templateDelimiters) &&
                      (u = i.parse(r.data, n)).length &&
                      (1 !== u.length || u[0].type !== i.types.text))
                  ) {
                    for (l = 0, h = u.length; l < h; l++)
                      (a = u[l]),
                        (o = document.createTextNode(a.value)),
                        r.parentNode.insertBefore(o, r),
                        1 === a.type &&
                          y.buildBinding("TextBinding", o, null, a.value);
                    r.parentNode.removeChild(r);
                  }
                } else 1 === r.nodeType && (t = y.traverse(r));
                if (!t) {
                  for (
                    f = [],
                      c = 0,
                      d = (p = (function () {
                        for (
                          var t = r.childNodes, e = [], n = 0, i = t.length;
                          n < i;
                          n++
                        )
                          (s = t[n]), e.push(s);
                        return e;
                      })()).length;
                    c < d;
                    c++
                  )
                    (e = p[c]), f.push(v(e));
                  return f;
                }
              },
              e = 0,
              n = (i = (y = this).els).length;
            e < n;
            e++
          )
            (t = i[e]), v(t);
          this.bindings.sort(function (t, e) {
            return (
              ((null != (e = e.binder) ? e.priority : void 0) || 0) -
              ((null != (e = t.binder) ? e.priority : void 0) || 0)
            );
          });
        }),
        (u.prototype.traverse = function (t) {
          for (
            var e,
              n,
              i,
              r,
              s,
              o,
              a,
              u,
              l,
              c,
              h = this.bindingRegExp(),
              d = "SCRIPT" === t.nodeName || "STYLE" === t.nodeName,
              p = t.attributes,
              f = 0,
              v = p.length;
            f < v;
            f++
          )
            if (((e = p[f]), h.test(e.name))) {
              if (((s = e.name.replace(h, "")), !(i = this.binders[s])))
                for (r in (l = this.binders))
                  (o = l[r]),
                    "*" !== r &&
                      -1 !== r.indexOf("*") &&
                      new RegExp("^" + r.replace(/\*/g, ".+") + "$").test(s) &&
                      (i = o);
              (i = i || this.binders["*"]).block && ((d = !0), (n = [e]));
            }
          for (a = 0, u = (c = n || t.attributes).length; a < u; a++)
            (e = c[a]),
              h.test(e.name) &&
                ((s = e.name.replace(h, "")),
                this.buildBinding("Binding", t, s, e.value));
          return (
            d ||
              ((s = t.nodeName.toLowerCase()),
              this.components[s] &&
                !t._bound &&
                (this.bindings.push(new _.ComponentBinding(this, t, s)),
                (d = !0))),
            d
          );
        }),
        (u.prototype.select = function (t) {
          for (
            var e, n = this.bindings, i = [], r = 0, s = n.length;
            r < s;
            r++
          )
            t((e = n[r])) && i.push(e);
          return i;
        }),
        (u.prototype.bind = function () {
          for (
            var t, e = this.bindings, n = [], i = 0, r = e.length;
            i < r;
            i++
          )
            (t = e[i]), n.push(t.bind());
          return n;
        }),
        (u.prototype.unbind = function () {
          for (
            var t, e = this.bindings, n = [], i = 0, r = e.length;
            i < r;
            i++
          )
            (t = e[i]), n.push(t.unbind());
          return n;
        }),
        (u.prototype.sync = function () {
          for (
            var t, e = this.bindings, n = [], i = 0, r = e.length;
            i < r;
            i++
          )
            (t = e[i]), n.push("function" == typeof t.sync ? t.sync() : void 0);
          return n;
        }),
        (u.prototype.publish = function () {
          for (
            var t,
              e = this.select(function (t) {
                return null != (t = t.binder) ? t.publishes : void 0;
              }),
              n = [],
              i = 0,
              r = e.length;
            i < r;
            i++
          )
            (t = e[i]), n.push(t.publish());
          return n;
        }),
        (u.prototype.update = function (t) {
          var e, n, i, r, s, o, a;
          for (n in (t = null == t ? {} : t)) (i = t[n]), (this.models[n] = i);
          for (a = [], r = 0, s = (o = this.bindings).length; r < s; r++)
            (e = o[r]),
              a.push("function" == typeof e.update ? e.update(t) : void 0);
          return a;
        }),
        u)),
      (_.Binding =
        ((l.prototype.setBinder = function () {
          var t, e, n;
          if (!(this.binder = this.view.binders[this.type]))
            for (t in (n = this.view.binders))
              (e = n[t]),
                "*" !== t &&
                  -1 !== t.indexOf("*") &&
                  new RegExp("^" + t.replace(/\*/g, ".+") + "$").test(
                    this.type
                  ) &&
                  ((this.binder = e),
                  (this.args = new RegExp(
                    "^" + t.replace(/\*/g, "(.+)") + "$"
                  ).exec(this.type)),
                  this.args.shift());
          if (
            (this.binder || (this.binder = this.view.binders["*"]),
            this.binder instanceof Function)
          )
            return (this.binder = { routine: this.binder });
        }),
        (l.prototype.observe = function (t, e, n) {
          return _.sightglass(t, e, n, {
            root: this.view.rootInterface,
            adapters: this.view.adapters,
          });
        }),
        (l.prototype.parseTarget = function () {
          var t = _.TypeParser.parse(this.keypath);
          return 0 === t.type
            ? (this.value = t.value)
            : ((this.observer = this.observe(
                this.view.models,
                this.keypath,
                this.sync
              )),
              (this.model = this.observer.target));
        }),
        (l.prototype.formattedValue = function (t) {
          for (
            var e,
              i,
              r,
              n,
              s,
              o,
              a,
              u,
              l,
              c,
              h = this.formatters,
              d = (u = 0),
              p = h.length;
            u < p;
            d = ++u
          ) {
            for (
              n = h[d],
                s = (r = n.match(
                  /[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g
                )).shift(),
                n = this.view.formatters[s],
                o = [],
                e = l = 0,
                c = (r = (function () {
                  for (var t = [], e = 0, n = r.length; e < n; e++)
                    (i = r[e]), t.push(_.TypeParser.parse(i));
                  return t;
                })()).length;
              l < c;
              e = ++l
            )
              (i = r[e]),
                o.push(
                  0 === i.type
                    ? i.value
                    : ((a = this.formatterObservers)[d] || (a[d] = {}),
                      (a = this.formatterObservers[d][e]) ||
                        ((a = this.observe(
                          this.view.models,
                          i.value,
                          this.sync
                        )),
                        (this.formatterObservers[d][e] = a)),
                      a.value())
                );
            (null != n ? n.read : void 0) instanceof Function
              ? (t = n.read.apply(n, [t].concat(f.call(o))))
              : n instanceof Function &&
                (t = n.apply(null, [t].concat(f.call(o))));
          }
          return t;
        }),
        (l.prototype.eventHandler = function (e) {
          var n,
            i = (n = this).view.handler;
          return function (t) {
            return i.call(e, this, t, n);
          };
        }),
        (l.prototype.set = function (t) {
          var e;
          return (
            (t =
              t instanceof Function && !this.binder.function
                ? this.formattedValue(t.call(this.model))
                : this.formattedValue(t)),
            null != (e = this.binder.routine)
              ? e.call(this, this.el, t)
              : void 0
          );
        }),
        (l.prototype.sync = function () {
          var a, u;
          return this.set(
            function () {
              var t, e, n, i, r, s, o;
              if (this.observer) {
                if (this.model !== this.observer.target) {
                  for (t = 0, n = (r = this.dependencies).length; t < n; t++)
                    (u = r[t]).unobserve();
                  if (
                    ((this.dependencies = []),
                    null != (this.model = this.observer.target) &&
                      null != (s = this.options.dependencies) &&
                      s.length)
                  )
                    for (
                      e = 0, i = (o = this.options.dependencies).length;
                      e < i;
                      e++
                    )
                      (a = o[e]),
                        (u = this.observe(this.model, a, this.sync)),
                        this.dependencies.push(u);
                }
                return this.observer.value();
              }
              return this.value;
            }.call(this)
          );
        }),
        (l.prototype.publish = function () {
          var t, e, n, i, r, s, o;
          if (this.observer) {
            for (
              n = this.getValue(this.el),
                r = (s = this.formatters.slice((i = 0)).reverse()).length;
              i < r;
              i++
            )
              (e = (t = s[i].split(/\s+/)).shift()),
                null != (o = this.view.formatters[e]) &&
                  o.publish &&
                  (n = (o = this.view.formatters[e]).publish.apply(
                    o,
                    [n].concat(f.call(t))
                  ));
            return this.observer.setValue(n);
          }
        }),
        (l.prototype.bind = function () {
          var t, e, n, i, r;
          if (
            (this.parseTarget(),
            null != (i = this.binder.bind) && i.call(this, this.el),
            null != this.model &&
              null != (i = this.options.dependencies) &&
              i.length)
          )
            for (e = 0, n = (r = this.options.dependencies).length; e < n; e++)
              (t = r[e]),
                (t = this.observe(this.model, t, this.sync)),
                this.dependencies.push(t);
          if (this.view.preloadData) return this.sync();
        }),
        (l.prototype.unbind = function () {
          var t, e, n, i, r, s, o, a;
          for (
            null != (s = this.binder.unbind) && s.call(this, this.el),
              null != (s = this.observer) && s.unobserve(),
              i = 0,
              r = (o = this.dependencies).length;
            i < r;
            i++
          )
            o[i].unobserve();
          for (n in ((this.dependencies = []), (a = this.formatterObservers)))
            for (t in (e = a[n])) e[t].unobserve();
          return (this.formatterObservers = {});
        }),
        (l.prototype.update = function (t) {
          var e;
          return (
            null == t && (t = {}),
            (this.model = null != (e = this.observer) ? e.target : void 0),
            null != (e = this.binder.update) ? e.call(this, t) : void 0
          );
        }),
        (l.prototype.getValue = function (t) {
          return this.binder && null != this.binder.getValue
            ? this.binder.getValue.call(this, t)
            : _.Util.getInputValue(t);
        }),
        l)),
      (_.ComponentBinding =
        ((e = _.Binding),
        t(c, e),
        (c.prototype.sync = function () {}),
        (c.prototype.update = function () {}),
        (c.prototype.publish = function () {}),
        (c.prototype.locals = function () {
          var t,
            e,
            n,
            i,
            r = {},
            s = this.static;
          for (t in s) (n = s[t]), (r[t] = n);
          for (t in (i = this.observers)) (e = i[t]), (r[t] = e.value());
          return r;
        }),
        (c.prototype.camelCase = function (t) {
          return t.replace(/-([a-z])/g, function (t) {
            return t[1].toUpperCase();
          });
        }),
        (c.prototype.bind = function () {
          var t, e, n, i, r, s, o, a, u, l, c, h, d, p, f, v, y, m, b, g, w;
          if (!this.bound) {
            for (e in (p = this.observers))
              (n = p[e]),
                (this.observers[e] = this.observe(
                  this.view.models,
                  n,
                  (function (e) {
                    return function (t) {
                      return function () {
                        return (e.componentView.models[t] =
                          e.observers[t].value());
                      };
                    };
                  })(this).call(this, e)
                ));
            this.bound = !0;
          }
          if (null != this.componentView) return this.componentView.bind();
          for (
            this.el.innerHTML = this.component.template.call(this),
              o = this.component.initialize.call(this, this.el, this.locals()),
              this.el._bound = !0,
              s = {},
              l = 0,
              h = (f = _.extensions).length;
            l < h;
            l++
          ) {
            if (((s[(r = f[l])] = {}), this.component[r]))
              for (t in (v = this.component[r])) (a = v[t]), (s[r][t] = a);
            for (t in (y = this.view[r]))
              (a = y[t]), null == (u = s[r])[t] && (u[t] = a);
          }
          for (c = 0, d = (m = _.options).length; c < d; c++)
            s[(r = m[c])] = null != (b = this.component[r]) ? b : this.view[r];
          for (e in ((this.componentView = new _.View(this.el, o, s)),
          this.componentView.bind(),
          (w = []),
          (g = this.observers)))
            (i = g[e]),
              w.push(
                (this.upstreamObservers[e] = this.observe(
                  this.componentView.models,
                  e,
                  (function (n) {
                    return function (t, e) {
                      return function () {
                        return e.setValue(n.componentView.models[t]);
                      };
                    };
                  })(this).call(this, e, i)
                ))
              );
          return w;
        }),
        (c.prototype.unbind = function () {
          var t,
            e,
            n,
            i = this.upstreamObservers;
          for (t in i) i[t].unobserve();
          for (t in (e = this.observers)) e[t].unobserve();
          return null != (n = this.componentView)
            ? n.unbind.call(this)
            : void 0;
        }),
        c)),
      (_.TextBinding =
        ((n = _.Binding),
        t(d, n),
        (d.prototype.binder = {
          routine: function (t, e) {
            return (t.data = null != e ? e : "");
          },
        }),
        (d.prototype.sync = function () {
          return d.__super__.sync.apply(this, arguments);
        }),
        d)),
      (_.public.binders.text = function (t, e) {
        return null != t.textContent
          ? (t.textContent = null != e ? e : "")
          : (t.innerText = null != e ? e : "");
      }),
      (_.public.binders.html = function (t, e) {
        return (t.innerHTML = null != e ? e : "");
      }),
      (_.public.binders.show = function (t, e) {
        return (t.style.display = e ? "" : "none");
      }),
      (_.public.binders.hide = function (t, e) {
        return (t.style.display = e ? "none" : "");
      }),
      (_.public.binders.enabled = function (t, e) {
        return (t.disabled = !e);
      }),
      (_.public.binders.disabled = function (t, e) {
        return (t.disabled = !!e);
      }),
      (_.public.binders.checked = {
        publishes: !0,
        priority: 2e3,
        bind: function (t) {
          return _.Util.bindEvent(t, "change", this.publish);
        },
        unbind: function (t) {
          return _.Util.unbindEvent(t, "change", this.publish);
        },
        routine: function (t, e) {
          var n;
          return "radio" === t.type
            ? (t.checked =
                (null != (n = t.value) ? n.toString() : void 0) ===
                (null != e ? e.toString() : void 0))
            : (t.checked = !!e);
        },
      }),
      (_.public.binders.unchecked = {
        publishes: !0,
        priority: 2e3,
        bind: function (t) {
          return _.Util.bindEvent(t, "change", this.publish);
        },
        unbind: function (t) {
          return _.Util.unbindEvent(t, "change", this.publish);
        },
        routine: function (t, e) {
          var n;
          return "radio" === t.type
            ? (t.checked =
                (null != (n = t.value) ? n.toString() : void 0) !==
                (null != e ? e.toString() : void 0))
            : (t.checked = !e);
        },
      }),
      (_.public.binders.value = {
        publishes: !0,
        priority: 3e3,
        bind: function (t) {
          if ("INPUT" !== t.tagName || "radio" !== t.type)
            return (
              (this.event = "SELECT" === t.tagName ? "change" : "input"),
              _.Util.bindEvent(t, this.event, this.publish)
            );
        },
        unbind: function (t) {
          if ("INPUT" !== t.tagName || "radio" !== t.type)
            return _.Util.unbindEvent(t, this.event, this.publish);
        },
        routine: function (t, e) {
          var n, i, r, s, o;
          if ("INPUT" === t.tagName && "radio" === t.type)
            return t.setAttribute("value", e);
          if (null != window.jQuery) {
            if (
              ((t = jQuery(t)),
              (null != e ? e.toString() : void 0) !==
                (null != (s = t.val()) ? s.toString() : void 0))
            )
              return t.val(null != e ? e : "");
          } else if ("select-multiple" === t.type) {
            if (null != e) {
              for (o = [], n = 0, i = t.length; n < i; n++)
                (r = t[n]),
                  o.push((r.selected = ((r = r.value), 0 <= h.call(e, r))));
              return o;
            }
          } else if (
            (null != e ? e.toString() : void 0) !==
            (null != (s = t.value) ? s.toString() : void 0)
          )
            return (t.value = null != e ? e : "");
        },
      }),
      (_.public.binders.if = {
        block: !0,
        priority: 4e3,
        bind: function (t) {
          var e, n;
          if (null == this.marker)
            return (
              (e = [this.view.prefix, this.type].join("-").replace("--", "-")),
              (n = t.getAttribute(e)),
              (this.marker = document.createComment(
                " rivets: " + this.type + " " + n + " "
              )),
              (this.bound = !1),
              t.removeAttribute(e),
              t.parentNode.insertBefore(this.marker, t),
              t.parentNode.removeChild(t)
            );
        },
        unbind: function () {
          var t;
          return null != (t = this.nested) ? t.unbind() : void 0;
        },
        routine: function (t, e) {
          var n, i, r, s;
          if (!!e == !this.bound) {
            if (e) {
              for (n in ((r = {}), (s = this.view.models)))
                (i = s[n]), (r[n] = i);
              return (
                (
                  this.nested ||
                  (this.nested = new _.View(t, r, this.view.options()))
                ).bind(),
                this.marker.parentNode.insertBefore(t, this.marker.nextSibling),
                (this.bound = !0)
              );
            }
            return (
              t.parentNode.removeChild(t),
              this.nested.unbind(),
              (this.bound = !1)
            );
          }
        },
        update: function (t) {
          var e;
          return null != (e = this.nested) ? e.update(t) : void 0;
        },
      }),
      (_.public.binders.unless = {
        block: !0,
        priority: 4e3,
        bind: function (t) {
          return _.public.binders.if.bind.call(this, t);
        },
        unbind: function () {
          return _.public.binders.if.unbind.call(this);
        },
        routine: function (t, e) {
          return _.public.binders.if.routine.call(this, t, !e);
        },
        update: function (t) {
          return _.public.binders.if.update.call(this, t);
        },
      }),
      (_.public.binders["on-*"] = {
        function: !0,
        priority: 1e3,
        unbind: function (t) {
          if (this.handler)
            return _.Util.unbindEvent(t, this.args[0], this.handler);
        },
        routine: function (t, e) {
          return (
            this.handler && _.Util.unbindEvent(t, this.args[0], this.handler),
            _.Util.bindEvent(
              t,
              this.args[0],
              (this.handler = this.eventHandler(e))
            )
          );
        },
      }),
      (_.public.binders["each-*"] = {
        block: !0,
        priority: 4e3,
        bind: function (t) {
          var e, n, i, r;
          if (null == this.marker)
            (e = [this.view.prefix, this.type].join("-").replace("--", "-")),
              (this.marker = document.createComment(
                " rivets: " + this.type + " "
              )),
              (this.iterated = []),
              t.removeAttribute(e),
              t.parentNode.insertBefore(this.marker, t),
              t.parentNode.removeChild(t);
          else
            for (n = 0, i = (r = this.iterated).length; n < i; n++) r[n].bind();
        },
        unbind: function (t) {
          var e, n, i, r, s;
          if (null != this.iterated) {
            for (s = [], n = 0, i = (r = this.iterated).length; n < i; n++)
              (e = r[n]), s.push(e.unbind());
            return s;
          }
        },
        routine: function (t, e) {
          var n,
            i,
            r,
            s,
            o,
            a,
            u,
            l,
            c,
            h,
            d,
            p,
            f,
            v,
            y,
            m,
            b,
            g,
            w,
            C = this.args[0];
          if (this.iterated.length > (e = e || []).length)
            for (
              h = 0, f = (m = Array(this.iterated.length - e.length)).length;
              h < f;
              h++
            )
              m[h],
                (c = this.iterated.pop()).unbind(),
                this.marker.parentNode.removeChild(c.els[0]);
          for (r = d = 0, v = e.length; d < v; r = ++d)
            if (
              ((o = e[r]),
              ((i = { index: r })[C] = o),
              null == this.iterated[r])
            ) {
              for (s in (b = this.view.models))
                (o = b[s]), null == i[s] && (i[s] = o);
              (u = this.iterated.length
                ? this.iterated[this.iterated.length - 1].els[0]
                : this.marker),
                ((a = this.view.options()).preloadData = !0),
                (l = t.cloneNode(!0)),
                (c = new _.View(l, i, a)).bind(),
                this.iterated.push(c),
                this.marker.parentNode.insertBefore(l, u.nextSibling);
            } else
              this.iterated[r].models[C] !== o && this.iterated[r].update(i);
          if ("OPTION" === t.nodeName) {
            for (w = [], p = 0, y = (g = this.view.bindings).length; p < y; p++)
              (n = g[p]).el === this.marker.parentNode && "value" === n.type
                ? w.push(n.sync())
                : w.push(void 0);
            return w;
          }
        },
        update: function (t) {
          var e,
            n,
            i,
            r,
            s,
            o,
            a,
            u = {};
          for (e in t) (n = t[e]), e !== this.args[0] && (u[e] = n);
          for (a = [], r = 0, s = (o = this.iterated).length; r < s; r++)
            (i = o[r]), a.push(i.update(u));
          return a;
        },
      }),
      (_.public.binders["class-*"] = function (t, e) {
        var n = " " + t.className + " ";
        if (!e == (-1 !== n.indexOf(" " + this.args[0] + " ")))
          return (t.className = e
            ? t.className + " " + this.args[0]
            : n.replace(" " + this.args[0] + " ", " ").trim());
      }),
      (_.public.binders["*"] = function (t, e) {
        return null != e
          ? t.setAttribute(this.type, e)
          : t.removeAttribute(this.type);
      }),
      (_.public.binders.size = function (t, e) {
        return (t.innerHTML =
          null != cartOptionsRef[e] && null != cartOptionsRef[e].size
            ? cartOptionsRef[e].size
            : "");
      }),
      (_.public.binders.colour = function (t, e) {
        return (t.innerHTML =
          null != cartOptionsRef[e] && null != cartOptionsRef[e].colour
            ? cartOptionsRef[e].colour
            : "");
      }),
      (_.public.binders.optionspayload = function (t, e) {
        return (t.innerHTML =
          null != cartOptionsRef[e] && null != cartOptionsRef[e].optionsPayload
            ? cartOptionsRef[e].optionsPayload
            : "");
      }),
      (_.public.adapters["."] = {
        id: "_rv",
        counter: 0,
        weakmap: {},
        weakReference: function (t) {
          var e;
          return (
            t.hasOwnProperty(this.id) ||
              ((e = this.counter++),
              Object.defineProperty(t, this.id, { value: e })),
            (e = this.weakmap)[(t = t[this.id])] || (e[t] = { callbacks: {} })
          );
        },
        cleanupWeakReference: function (t, e) {
          if (
            !(
              Object.keys(t.callbacks).length ||
              (t.pointers && Object.keys(t.pointers).length)
            )
          )
            return delete this.weakmap[e];
        },
        stubFunction: function (u, t) {
          var l = u[t],
            c = this.weakReference(u),
            h = this.weakmap;
          return (u[t] = function () {
            var t,
              e,
              n,
              i,
              r,
              s,
              o = l.apply(u, arguments),
              a = c.pointers;
            for (e in a)
              for (
                t = a[e],
                  n = 0,
                  i = (s =
                    null != (r = null != (r = h[e]) ? r.callbacks[t] : void 0)
                      ? r
                      : []).length;
                n < i;
                n++
              )
                (0, s[n])();
            return o;
          });
        },
        observeMutations: function (t, e, n) {
          var i, r, s, o, a;
          if (Array.isArray(t)) {
            if (null == (r = this.weakReference(t)).pointers)
              for (
                r.pointers = {},
                  o = 0,
                  a = (i = [
                    "push",
                    "pop",
                    "shift",
                    "unshift",
                    "sort",
                    "reverse",
                    "splice",
                  ]).length;
                o < a;
                o++
              )
                this.stubFunction(t, i[o]);
            if (
              (null == (s = r.pointers)[e] && (s[e] = []),
              h.call(r.pointers[e], n) < 0)
            )
              return r.pointers[e].push(n);
          }
        },
        unobserveMutations: function (t, e, n) {
          var i, r;
          if (
            Array.isArray(t) &&
            null != t[this.id] &&
            (i = this.weakmap[t[this.id]]) &&
            (r = i.pointers[e])
          )
            return (
              0 <= (n = r.indexOf(n)) && r.splice(n, 1),
              r.length || delete i.pointers[e],
              this.cleanupWeakReference(i, t[this.id])
            );
        },
        observe: function (s, o, a) {
          var t,
            u,
            l,
            c = this.weakReference(s).callbacks;
          return (
            null == c[o] &&
              ((c[o] = []),
              (null != (t = Object.getOwnPropertyDescriptor(s, o)) && t.get) ||
                (null != t && t.set) ||
                ((u = s[o]),
                Object.defineProperty(s, o, {
                  enumerable: !0,
                  get: function () {
                    return u;
                  },
                  set:
                    ((l = this),
                    function (t) {
                      var e, n, i, r;
                      if (
                        t !== u &&
                        (l.unobserveMutations(u, s[l.id], o),
                        (u = t),
                        (e = l.weakmap[s[l.id]]))
                      ) {
                        if ((c = e.callbacks)[o])
                          for (n = 0, i = (r = c[o].slice()).length; n < i; n++)
                            (a = r[n]), 0 <= h.call(c[o], a) && a();
                        return l.observeMutations(t, s[l.id], o);
                      }
                    }),
                }))),
            h.call(c[o], a) < 0 && c[o].push(a),
            this.observeMutations(s[o], s[this.id], o)
          );
        },
        unobserve: function (t, e, n) {
          var i, r;
          if ((r = this.weakmap[t[this.id]]) && (i = r.callbacks[e]))
            return (
              0 <= (n = i.indexOf(n)) &&
                (i.splice(n, 1), i.length || delete r.callbacks[e]),
              this.unobserveMutations(t[e], t[this.id], e),
              this.cleanupWeakReference(r, t[this.id])
            );
        },
        get: function (t, e) {
          return t[e];
        },
        set: function (t, e, n) {
          return (t[e] = n);
        },
      }),
      (_.factory = function (t) {
        return (_.sightglass = t), (_.public._ = _).public;
      }),
      "object" ==
      typeof ("undefined" != typeof module && null !== module
        ? module.exports
        : void 0)
        ? (module.exports = _.factory(require("sightglass")))
        : "function" == typeof define && define.amd
        ? define(["sightglass"], function (t) {
            return (this.rivets = _.factory(t));
          })
        : (this.rivets = _.factory(sightglass));
  }.call(this),
  function () {
    function e(t, e) {
      return function () {
        return t.apply(e, arguments);
      };
    }
    var n,
      t,
      s,
      o,
      i,
      r,
      a =
        [].indexOf ||
        function (t) {
          for (var e = 0, n = this.length; e < n; e++)
            if (e in this && this[e] === t) return e;
          return -1;
        };
    function u() {
      this.update = e(this.update, this);
    }
    function l(t) {
      (this.propertyArray = e(this.propertyArray, this)),
        (this.update = e(this.update, this)),
        this.update(t);
    }
    (u.prototype.update = function (r) {
      var s, t, e;
      for (t in r) (e = r[t]), "items" !== t && (this[t] = e);
      return (this.items = (function () {
        for (var t = r.items, e = [], n = 0, i = t.length; n < i; n++)
          (s = t[n]), e.push(new o(s));
        return e;
      })());
    }),
      (t = u),
      (l.prototype.update = function (t) {
        var e, n;
        for (e in t) (n = t[e]), "properties" !== e && (this[e] = n);
        return (this.properties = s.Utils.extend({}, t.properties));
      }),
      (l.prototype.propertyArray = function () {
        var t,
          e,
          n = this.properties,
          i = [];
        for (t in n) (e = n[t]), i.push({ name: t, value: e });
        return i;
      }),
      (o = l),
      (s = {
        settings: {
          debug: !1,
          dataAPI: !0,
          requestBodyClass: null,
          rivetsModels: {},
          currency: null,
          moneyFormat: null,
          moneyWithCurrencyFormat: null,
          weightUnit: "g",
          weightPrecision: 0,
        },
        cart: new t(),
        init: function (t, e) {
          return (
            s.configure((e = null == e ? {} : e)),
            s.Utils.log("Initialising CartJS."),
            s.cart.update(t),
            s.settings.dataAPI &&
              (s.Utils.log('"dataAPI" setting is true, initialising Data API.'),
              s.Data.init()),
            s.settings.requestBodyClass &&
              (s.Utils.log('"requestBodyClass" set, adding event listeners.'),
              jQuery(document).on("cart.requestStarted", function () {
                return jQuery("body").addClass(s.settings.requestBodyClass);
              }),
              jQuery(document).on("cart.requestComplete", function () {
                return jQuery("body").removeClass(s.settings.requestBodyClass);
              })),
            (s.cart = supplementCart(s.cart)),
            s.Core.getCart(),
            s.Rivets.init(),
            jQuery(document).trigger("cart.ready", [s.cart])
          );
        },
        configure: function (t) {
          return s.Utils.extend(s.settings, (t = null == t ? {} : t));
        },
      }),
      null == window.console &&
        ((window.console = {}), (window.console.log = function () {})),
      (s.Utils = {
        log: function () {
          return s.Utils.console(console.log, arguments);
        },
        warn: function () {
          return s.Utils.console(console.warn, arguments);
        },
        error: function () {
          return s.Utils.console(console.error, arguments);
        },
        console: function (t, e) {
          if (
            s.settings.debug &&
            "undefined" != typeof console &&
            null !== console
          )
            return (
              (e = Array.prototype.slice.call(e)).unshift("[CartJS]:"),
              t.apply(console, e)
            );
        },
        wrapKeys: function (t, e, n, i) {
          var r, s, o;
          for (r in (null == e && (e = "properties"),
          null == i && (i = []),
          (o = {}),
          t))
            (s = t[r]),
              (o[0 <= a.call(i, r) ? r : e + "[" + r + "]"] =
                null != n ? n : s);
          return o;
        },
        unwrapKeys: function (t, e, n) {
          var i, r, s;
          for (i in (null == e && (e = "properties"), (r = {}), t))
            (s = t[i]),
              (r[i.replace(e + "[", "").replace("]", "")] = null != n ? n : s);
          return r;
        },
        extend: function (t, e) {
          var n, i;
          for (n in e) (i = e[n]), (t[n] = i);
          return t;
        },
        clone: function (t) {
          var e, n;
          if (null == t || "object" != typeof t) return t;
          for (e in ((n = new t.constructor()), t)) n[e] = clone(t[e]);
          return n;
        },
        delete: function (t, e) {
          var n = t[e];
          return delete t[e], n;
        },
        isArray:
          Array.isArray ||
          function (t) {
            return "[object Array]" === {}.toString.call(t);
          },
        ensureArray: function (t) {
          return s.Utils.isArray(t) ? t : null != t ? [t] : [];
        },
        formatMoney: function (t, e, n, i) {
          var r;
          return (
            (i = (i = null == i ? "" : i) || s.settings.currency),
            null != window.Currency &&
              i !== s.settings.currency &&
              ((t = Currency.convert(t, s.settings.currency, i)),
              null !=
                (null != (r = window.Currency) ? r.moneyFormats : void 0)) &&
              i in window.Currency.moneyFormats &&
              (e = window.Currency.moneyFormats[i][n]),
            null != (null != (r = window.Shopify) ? r.formatMoney : void 0)
              ? Shopify.formatMoney(t, e)
              : (s.Utils.warn(
                  'A money formatting filter was used, but Shopify.formatMoney is not available. See the note "Dependency when formatting monetary values" on this page: https://cartjs.org/pages/guide#getting-started-setup.'
                ),
                t)
          );
        },
        getSizedImageUrl: function (t, e) {
          var n;
          return null !=
            (null != (n = window.Shopify) && null != (n = n.Image)
              ? n.getSizedImageUrl
              : void 0)
            ? t
              ? Shopify.Image.getSizedImageUrl(t, e)
              : Shopify.Image.getSizedImageUrl(
                  "https://cdn.shopify.com/s/images/admin/no-image-.gif",
                  e
                ).replace("-_", "-")
            : t || "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
        },
      }),
      (i = !(r = [])),
      (s.Queue = {
        add: function (t, e, n) {
          t = {
            url: t,
            data: e,
            type: (n = null == n ? {} : n).type || "POST",
            dataType: n.dataType || "json",
            cache: !!n.cache,
            success: s.Utils.ensureArray(n.success),
            error: s.Utils.ensureArray(n.error),
            complete: s.Utils.ensureArray(n.complete),
          };
          if ((n.updateCart && t.success.push(s.cart.update), r.push(t), !i))
            return (
              jQuery(document).trigger("cart.requestStarted", [s.cart]),
              s.Queue.process()
            );
        },
        process: function () {
          var t;
          if (r.length)
            return (
              (i = !0),
              ((t = r.shift()).complete = s.Queue.process),
              jQuery.ajax(t)
            );
          (i = !1),
            (s.cart = supplementCart(s.cart)),
            jQuery(document).trigger("cart.requestComplete", [s.cart]);
        },
      }),
      (s.Core = {
        getCart: function (t) {
          return (
            ((t = null == t ? {} : t).type = "GET"),
            (t.updateCart = !0),
            s.Queue.add("/cart.js", { v: new Date().getTime() }, t)
          );
        },
        addItem: function (t, e, n, i) {
          return (
            null == e && (e = 1),
            null == i && (i = {}),
            ((n = s.Utils.wrapKeys((n = null == n ? {} : n), null, null, [
              "selling_plan",
            ])).id = t),
            (n.quantity = e),
            s.Queue.add("/cart/add.js", n, i),
            s.Core.getCart()
          );
        },
        addItems: function (t, e) {
          return (
            s.Queue.add("/cart/add.js", { items: t }, (e = null == e ? {} : e)),
            s.Core.getCart()
          );
        },
        updateItem: function (t, e, n, i) {
          return (
            null == i && (i = {}),
            ((n = s.Utils.wrapKeys((n = null == n ? {} : n), null, null, [
              "selling_plan",
            ])).line = t),
            null != e && (n.quantity = e),
            (i.updateCart = !0),
            s.Queue.add("/cart/change.js", n, i)
          );
        },
        removeItem: function (t, e) {
          return s.Core.updateItem(t, 0, {}, (e = null == e ? {} : e));
        },
        updateItemById: function (t, e, n, i) {
          return (
            null == i && (i = {}),
            ((n = s.Utils.wrapKeys((n = null == n ? {} : n), null, null, [
              "selling_plan",
            ])).id = t),
            null != e && (n.quantity = e),
            (i.updateCart = !0),
            s.Queue.add("/cart/change.js", n, i)
          );
        },
        updateItemQuantitiesById: function (t, e) {
          return (
            null == t && (t = {}),
            ((e = null == e ? {} : e).updateCart = !0),
            s.Queue.add("/cart/update.js", { updates: t }, e)
          );
        },
        removeItemById: function (t, e) {
          t = { id: t, quantity: 0 };
          return (
            ((e = null == e ? {} : e).updateCart = !0),
            s.Queue.add("/cart/change.js", t, e)
          );
        },
        clear: function (t) {
          return (
            ((t = null == t ? {} : t).updateCart = !0),
            s.Queue.add("/cart/clear.js", {}, t)
          );
        },
        getAttribute: function (t, e) {
          return t in s.cart.attributes ? s.cart.attributes[t] : e;
        },
        setAttribute: function (t, e, n) {
          var i;
          return (
            null == n && (n = {}), ((i = {})[t] = e), s.Core.setAttributes(i, n)
          );
        },
        getAttributes: function () {
          return s.cart.attributes;
        },
        setAttributes: function (t, e) {
          return (
            null == t && (t = {}),
            ((e = null == e ? {} : e).updateCart = !0),
            s.Queue.add("/cart/update.js", s.Utils.wrapKeys(t, "attributes"), e)
          );
        },
        clearAttributes: function (t) {
          return (
            ((t = null == t ? {} : t).updateCart = !0),
            s.Queue.add(
              "/cart/update.js",
              s.Utils.wrapKeys(s.Core.getAttributes(), "attributes", ""),
              t
            )
          );
        },
        getNote: function () {
          return s.cart.note;
        },
        setNote: function (t, e) {
          return (
            ((e = null == e ? {} : e).updateCart = !0),
            s.Queue.add("/cart/update.js", { note: t }, e)
          );
        },
      }),
      (n = null),
      (s.Data = {
        init: function () {
          return (
            (n = jQuery(document)),
            s.Data.setEventListeners("on"),
            s.Data.render(null, s.cart)
          );
        },
        destroy: function () {
          return s.Data.setEventListeners("off");
        },
        setEventListeners: function (t) {
          return (
            n[t]("click", "[data-cart-add]", s.Data.add),
            n[t]("click", "[data-cart-remove]", s.Data.remove),
            n[t]("click", "[data-cart-remove-id]", s.Data.removeById),
            n[t]("click", "[data-cart-remove-bundle]", s.Data.removeBundle),
            n[t]("change", "[data-cart-update]", s.Data.update),
            n[t]("click", "[data-cart-update-id]", s.Data.updateById),
            n[t]("click", "[data-cart-clear]", s.Data.clear),
            n[t]("change", "[data-cart-toggle]", s.Data.toggle),
            n[t](
              "change",
              "[data-cart-toggle-attribute]",
              s.Data.toggleAttribute
            ),
            n[t]("submit", "[data-cart-submit]", s.Data.submit),
            n[t]("cart.requestComplete", s.Data.render)
          );
        },
        add: function (t) {
          var e;
          return (
            t.preventDefault(),
            (t = jQuery(this)),
            ((e = {}).selling_plan = t.attr("data-cart-selling-plan")),
            s.Core.addItem(
              t.attr("data-cart-add"),
              t.attr("data-cart-quantity"),
              e
            )
          );
        },
        remove: function (t) {
          return (
            t.preventDefault(),
            (t = jQuery(this)),
            s.Core.removeItem(t.attr("data-cart-remove"))
          );
        },
        removeById: function (t) {
          return (
            t.preventDefault(),
            (t = jQuery(this)),
            s.Core.removeItemById(t.attr("data-cart-remove-id"))
          );
        },
        removeBundle: function (t) {
          t.preventDefault();
          var e = jQuery(this).attr("data-cart-remove-bundle"),
            t = s.cart.items.filter((t) => t.properties._bundle_id === e),
            n = {};
          return (
            t.forEach((t) => {
              (n[t.key] = 0), t.addOn && (n[t.addOn.key] = 0);
            }),
            s.Core.updateItemQuantitiesById(n)
          );
        },
        update: function (t) {
          var e;
          return (
            t.preventDefault(),
            (t = jQuery(this)),
            ((e = {}).selling_plan = t.attr("data-cart-selling-plan")),
            s.Core.updateItem(
              t.attr("data-cart-update"),
              t.attr("data-cart-quantity"),
              e
            )
          );
        },
        updateById: function (t) {
          var e;
          return (
            t.preventDefault(),
            (t = jQuery(this)),
            ((e = {}).selling_plan = t.attr("data-cart-selling-plan")),
            s.Core.updateItemById(
              t.attr("data-cart-update-id"),
              t.attr("data-cart-quantity"),
              e
            )
          );
        },
        clear: function (t) {
          return t.preventDefault(), s.Core.clear();
        },
        toggle: function (t) {
          var e = jQuery(this),
            n = e.attr("data-cart-toggle");
          return e.is(":checked")
            ? s.Core.addItem(n)
            : s.Core.removeItemById(n);
        },
        toggleAttribute: function (t) {
          var e = jQuery(this),
            n = e.attr("data-cart-toggle-attribute");
          return s.Core.setAttribute(n, e.is(":checked") ? "Yes" : "");
        },
        submit: function (t) {
          var n, i, r;
          return (
            t.preventDefault(),
            (t = jQuery(this).serializeArray()),
            (r = n = void 0),
            (i = {}),
            jQuery.each(t, function (t, e) {
              return "id" === e.name
                ? (n = e.value)
                : "quantity" === e.name
                ? (r = e.value)
                : "selling_plan" === e.name
                ? (i.selling_plan = e.value)
                : e.name.match(/^properties\[[\w-_ ]*\]$/)
                ? (i[e.name] = e.value)
                : void 0;
            }),
            s.Core.addItem(n, r, s.Utils.unwrapKeys(i))
          );
        },
        render: function (t, e) {
          var n = {
            item_count: e.item_count,
            total_price: e.total_price,
            total_price_money: s.Utils.formatMoney(
              e.total_price,
              s.settings.moneyFormat,
              "money_format",
              null !=
                ("undefined" != typeof Currency && null !== Currency
                  ? Currency.currentCurrency
                  : void 0)
                ? Currency.currentCurrency
                : void 0
            ),
            total_price_money_with_currency: s.Utils.formatMoney(
              e.total_price,
              s.settings.moneyWithCurrencyFormat,
              "money_with_currency_format",
              null !=
                ("undefined" != typeof Currency && null !== Currency
                  ? Currency.currentCurrency
                  : void 0)
                ? Currency.currentCurrency
                : void 0
            ),
          };
          return (
            $(".cart_item").removeClass("shrink_out"),
            jQuery("[data-cart-render]").each(function () {
              var t = jQuery(this);
              return t.html(n[t.attr("data-cart-render")]);
            })
          );
        },
      }),
      "undefined" != typeof rivets && null !== rivets
        ? ((s.Rivets = {
            model: null,
            boundViews: [],
            init: function () {
              return s.Rivets.bindViews();
            },
            destroy: function () {
              return s.Rivets.unbindViews();
            },
            bindViews: function () {
              return (
                s.Utils.log("Rivets.js is present, binding views."),
                s.Rivets.unbindViews(),
                (s.Rivets.model = s.Utils.extend(
                  { cart: s.cart },
                  s.settings.rivetsModels
                )),
                null != window.Currency &&
                  (s.Rivets.model.Currency = window.Currency),
                jQuery("[data-cart-view]").each(function () {
                  var t = rivets.bind(jQuery(this), s.Rivets.model);
                  return s.Rivets.boundViews.push(t);
                })
              );
            },
            unbindViews: function () {
              for (var t = s.Rivets.boundViews, e = 0, n = t.length; e < n; e++)
                t[e].unbind();
              return (s.Rivets.boundViews = []);
            },
          }),
          (rivets.formatters.eq = function (t, e) {
            return t === e;
          }),
          (rivets.formatters.includes = function (t, e) {
            return 0 <= t.indexOf(e);
          }),
          (rivets.formatters.match = function (t, e, n) {
            return t.match(new RegExp(e, n));
          }),
          (rivets.formatters.lt = function (t, e) {
            return t < e;
          }),
          (rivets.formatters.gt = function (t, e) {
            return e < t;
          }),
          (rivets.formatters.lte = function (t, e) {
            return t <= e;
          }),
          (rivets.formatters.gte = function (t, e) {
            return e <= t;
          }),
          (rivets.formatters.if_gt_zero = function (t) {
            return 0 < t ? t : "";
          }),
          (rivets.formatters.not = function (t) {
            return !t;
          }),
          (rivets.formatters.empty = function (t) {
            return !t.length;
          }),
          (rivets.formatters.plus = function (t, e) {
            return parseInt(t) + parseInt(e);
          }),
          (rivets.formatters.minus = function (t, e) {
            return parseInt(t) - parseInt(e);
          }),
          (rivets.formatters.times = function (t, e) {
            return t * e;
          }),
          (rivets.formatters.divided_by = function (t, e) {
            return t / e;
          }),
          (rivets.formatters.modulo = function (t, e) {
            return t % e;
          }),
          (rivets.formatters.prepend = function (t, e) {
            return e + t;
          }),
          (rivets.formatters.append = function (t, e) {
            return t + e;
          }),
          (rivets.formatters.logic_and = function (t, e) {
            return t && e;
          }),
          (rivets.formatters.logic_or = function (t, e) {
            return t || e;
          }),
          (rivets.formatters.slice = function (t, e, n) {
            return t.slice(e, n);
          }),
          (rivets.formatters.pluralize = function (t, e, n) {
            return (
              null == n && (n = e + "s"),
              1 === (t = s.Utils.isArray(t) ? t.length : t) ? e : n
            );
          }),
          (rivets.formatters.array_element = function (t, e) {
            return t[e];
          }),
          (rivets.formatters.array_first = function (t) {
            return t[0];
          }),
          (rivets.formatters.array_last = function (t) {
            return t[t.length - 1];
          }),
          (rivets.formatters.money = function (t, e) {
            return s.Utils.formatMoney(
              t,
              s.settings.moneyFormat,
              "money_format",
              e
            );
          }),
          (rivets.formatters.money_with_currency = function (t, e) {
            return s.Utils.formatMoney(
              t,
              s.settings.moneyWithCurrencyFormat,
              "money_with_currency_format",
              e
            );
          }),
          (rivets.formatters.without_trailing_zeroes = function (t) {
            return t.replace(".00", "");
          }),
          (rivets.formatters.money_flat_amount = function (t) {
            return t / 100;
          }),
          (rivets.formatters.weight = function (t) {
            switch (s.settings.weightUnit) {
              case "kg":
                return (t / 1e3).toFixed(s.settings.weightPrecision);
              case "oz":
                return (0.035274 * t).toFixed(s.settings.weightPrecision);
              case "lb":
                return (0.00220462 * t).toFixed(s.settings.weightPrecision);
              default:
                return t.toFixed(s.settings.weightPrecision);
            }
          }),
          (rivets.formatters.weight_with_unit = function (t) {
            return rivets.formatters.weight(t) + s.settings.weightUnit;
          }),
          (rivets.formatters.image_size = function (t, e) {
            return s.Utils.getSizedImageUrl(t, e);
          }),
          (rivets.formatters.tag_by_prefix = function (t, e) {
            if (t)
              return (
                (t = t
                  .map((t) => {
                    t = t.split(":");
                    return { prefix: t[0], value: t[1] };
                  })
                  .filter((t) => t.prefix === e)),
                "cart_line" === e
                  ? 0 < t.length
                    ? t[0].value
                    : ""
                  : 0 < t.length
                  ? t.map((t) => t.value)
                  : ""
              );
          }),
          (rivets.formatters.count_by_tag = function (t, e) {
            return t.filter((t) => !!t.tags && -1 !== t.tags.indexOf(e)).length;
          }),
          (rivets.formatters.more_tag_than_tag = function (t, e, n) {
            var i = t.filter(
                (t) => !!t.tags && -1 !== t.tags.indexOf(e)
              ).length,
              t = t.filter((t) => !!t.tags && -1 !== t.tags.indexOf(n)).length;
            return 0 < i && 0 < t && t < i;
          }),
          (rivets.formatters.halo_from_colour = function (t) {
            var e = window.vars.halos;
            return t ? e[t] : e.grey;
          }),
          (rivets.formatters.halo = function (t, e) {
            var n, i;
            if (t)
              return (
                (n = rivets.formatters.tag_by_prefix(t, "halo")[0] || !1),
                (t =
                  rivets.formatters.tag_by_prefix(t, "halo_colour")[0] || !1),
                n
                  ? ((t = t || "blue"),
                    (i = "price" === n),
                    (e = s.Utils.formatMoney(
                      e,
                      s.settings.moneyFormat,
                      "money_format"
                    )
                      .replace(".00", "")
                      .replace("$", "")),
                    [
                      '<div class="halo_display">',
                      rivets.formatters.halo_from_colour(t),
                      '<div class="halo_text">',
                      i
                        ? `<span class="halo_price chars_${e.length}"><span>$</span>${e}</span>`
                        : n,
                      "</div>",
                      "</div>",
                    ].join(""))
                  : ""
              );
          }),
          (rivets.formatters.moneyWithCurrency =
            rivets.formatters.money_with_currency),
          (rivets.formatters.weightWithUnit =
            rivets.formatters.weight_with_unit),
          (rivets.formatters.imageSize = rivets.formatters.image_size))
        : (s.Rivets = { init: function () {}, destroy: function () {} }),
      (s.factory = function (t) {
        return (
          (t.init = s.init),
          (t.configure = s.configure),
          (t.cart = s.cart),
          (t.settings = s.settings),
          (t.getCart = s.Core.getCart),
          (t.addItem = s.Core.addItem),
          (t.addItems = s.Core.addItems),
          (t.updateItem = s.Core.updateItem),
          (t.updateItemById = s.Core.updateItemById),
          (t.updateItemQuantitiesById = s.Core.updateItemQuantitiesById),
          (t.removeItem = s.Core.removeItem),
          (t.removeItemById = s.Core.removeItemById),
          (t.clear = s.Core.clear),
          (t.getAttribute = s.Core.getAttribute),
          (t.setAttribute = s.Core.setAttribute),
          (t.getAttributes = s.Core.getAttributes),
          (t.setAttributes = s.Core.setAttributes),
          (t.clearAttributes = s.Core.clearAttributes),
          (t.getNote = s.Core.getNote),
          (t.setNote = s.Core.setNote),
          (t.render = s.Data.render)
        );
      }),
      "object" == typeof exports
        ? s.factory(exports)
        : "function" == typeof define && define.amd
        ? define(["exports"], function (t) {
            return s.factory((this.CartJS = t)), t;
          })
        : s.factory((this.CartJS = {}));
  }.call(this),
  CartJS.init.apply(this, window.vars.cartJSSetup);
